import { Injectable } from '@angular/core';
import { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export abstract class CommandService {

  constructor(private toast: ToastController) { }

  public abstract sendMessage();
  public abstract receiveResponse(res);

  public device: any;
  public cmd: any;
  public ble: BLE;

  public setDevice(device: any, ble: BLE) {
    this.device = device;
    this.ble = ble;
    this.device.serviceUUID = '49535343-fe7d-4ae5-8fa9-9fafd205e455';
    this.device.txUUID = '49535343-1e4d-4bd9-ba61-23c647249616';
    this.device.rxUUID = '49535343-8841-43f4-a8d4-ecbe34729bb3';
  }

  public hexTobytes(s) {
    console.log("Hex à envoyer : ", s);

    var bytes = new Uint8Array(s.length / 2);
    for (let c = 0; c < s.length; c += 2)
      bytes[c / 2] = parseInt(s.substr(c, 2), 16);

    console.log("Bytes envoyés : ", bytes);
    return bytes.buffer;
  }

  public buf2hex(buffer) { // buffer is an ArrayBuffer
    return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
  }

  public bytesToString(buffer) {
    return String.fromCharCode.apply(null, new Uint8Array(buffer));
  }

  public stringToBytes(string) {
    var array = new Uint8Array(string.length);
    for (var i = 0, l = string.length; i < l; i++) {
      array[i] = string.charCodeAt(i);
    }
    return array.buffer;
  }

  public littleToBigEndian(endian) {
    console.log("Endian : ", endian)
    let arr = endian.match(/.{1,2}/g);
    //  console.log("Array : ", arr);

    arr.reverse();

    let result = '';
    for (let i = 0; i < arr.length; i++) {
      result += arr[i];
    }

    //console.log(result);
    return result;
  }

  public async successCmd(msg) {
    const toast = await this.toast.create({
      message: msg,
      duration: 1000,
      color: 'success'
    });
    toast.present();
  }

  public async failedCmd(msg) {
    const toast = await this.toast.create({
      message: msg,
      duration: 1000,
      color: 'danger'
    });
    toast.present();
  }
}